<template>
  <div>
    <!-- hero -->
    <section class="hero">
      <div class="hero-wrapper parallax-trigger">
        <div class="hero-text">
          <h2>Land Your Dream Job with</h2>
          <h1>Interview<span>ACE</span></h1>
          <p class="sub-heading">
            <svg
              xmlns="http://www.w3.org/2000/svg" width="72" height="21"
              viewBox="0 0 72 21" fill="none"
            >
              <g clip-path="url(#clip0_4483_103525)">
                <path d="M22.4199 9.88901C22.4199 13.0814 24.4701 15.3073 27.311 15.3073C30.152 15.3073 32.2022 13.0814 32.2022 9.88901C32.2022 6.6966 30.152 4.4707 27.311 4.4707C24.4701 4.4707 22.4199 6.6966 22.4199 9.88901ZM30.3277 9.88901C30.3277 12.1735 29.083 13.6525 27.311 13.6525C25.5391 13.6525 24.2944 12.1735 24.2944 9.88901C24.2944 7.60453 25.5391 6.12548 27.311 6.12548C29.083 6.12548 30.3277 7.60453 30.3277 9.88901Z" fill="#748190" />
                <path d="M37.4803 15.3072C39.6329 15.3072 40.863 13.4913 40.863 11.3094C40.863 9.12739 39.6329 7.31152 37.4803 7.31152C36.4845 7.31152 35.7523 7.70691 35.269 8.27803V7.45796H33.5117V17.782H35.269V14.3407C35.7523 14.9118 36.4845 15.3072 37.4803 15.3072ZM35.2251 11.0897C35.2251 9.63993 36.0451 8.84915 37.1288 8.84915C38.4028 8.84915 39.0911 9.84495 39.0911 11.3094C39.0911 12.7738 38.4028 13.7696 37.1288 13.7696C36.0451 13.7696 35.2251 12.9641 35.2251 11.5437V11.0897Z" fill="#748190" />
                <path d="M45.619 15.3072C47.1566 15.3072 48.3721 14.5018 48.9139 13.1545L47.4056 12.5834C47.1713 13.3742 46.483 13.8135 45.619 13.8135C44.4914 13.8135 43.7006 13.0081 43.5688 11.6901H48.9578V11.1043C48.9578 8.99559 47.7717 7.31152 45.5458 7.31152C43.3199 7.31152 41.8848 9.05417 41.8848 11.3094C41.8848 13.6817 43.4224 15.3072 45.619 15.3072ZM45.5311 8.79057C46.6441 8.79057 47.1713 9.52278 47.1859 10.3721H43.6567C43.9203 9.3324 44.6232 8.79057 45.5311 8.79057Z" fill="#748190" />
                <path d="M50.2773 15.1461H52.0346V10.6357C52.0346 9.53742 52.8401 8.95166 53.6308 8.95166C54.5973 8.95166 54.9781 9.63993 54.9781 10.5918V15.1461H56.7354V10.0793C56.7354 8.42447 55.7689 7.31152 54.158 7.31152C53.1622 7.31152 52.474 7.76549 52.0346 8.27803V7.45796H50.2773V15.1461Z" fill="#748190" />
                <path d="M61.8816 4.63184L57.8984 15.1463H59.7582L60.6515 12.7446H65.1912L66.0991 15.1463H67.9882L64.005 4.63184H61.8816ZM62.9067 6.71129L64.5761 11.1045H61.2666L62.9067 6.71129Z" fill="#748190" />
                <path
                  d="M71.0053 4.66211H69.1309V15.1766H71.0053V4.66211Z" fill="#748190"
                />
                <path d="M18.1266 8.49343C18.5696 7.16387 18.417 5.7074 17.7086 4.49804C16.6433 2.64313 14.5016 1.68882 12.4099 2.13791C11.4794 1.08964 10.1425 0.493501 8.74097 0.502044C6.60294 0.497162 4.70592 1.8737 4.04816 3.90801C2.67467 4.1893 1.48911 5.04903 0.795346 6.26754C-0.277942 8.11757 -0.0332639 10.4496 1.40063 12.0361C0.957651 13.3656 1.11019 14.8221 1.8186 16.0315C2.88396 17.8864 5.02565 18.8407 7.11731 18.3916C8.04721 19.4399 9.3847 20.036 10.7863 20.0269C12.9255 20.0323 14.8231 18.6546 15.4809 16.6185C16.8544 16.3372 18.04 15.4774 18.7337 14.2589C19.8058 12.4089 19.5605 10.0787 18.1272 8.49221L18.1266 8.49343ZM10.7875 18.751C9.93141 18.7522 9.10219 18.4526 8.44504 17.9041C8.47494 17.8882 8.5268 17.8595 8.56036 17.8388L12.4484 15.5934C12.6473 15.4805 12.7693 15.2688 12.7681 15.0399V9.55879L14.4113 10.5076C14.429 10.5161 14.4406 10.5332 14.443 10.5528V15.0918C14.4406 17.1102 12.8059 18.7467 10.7875 18.751ZM2.92606 15.3932C2.49711 14.6525 2.34274 13.7842 2.48979 12.9416C2.51846 12.9587 2.56911 12.9898 2.60511 13.0105L6.49311 15.2559C6.69019 15.3713 6.93426 15.3713 7.13196 15.2559L11.8785 12.5151V14.4127C11.8797 14.4322 11.8705 14.4511 11.8553 14.4633L7.92518 16.7326C6.1746 17.7406 3.93894 17.1414 2.92667 15.3932H2.92606ZM1.9028 6.90638C2.32992 6.16442 3.00416 5.59696 3.80714 5.30225C3.80714 5.33581 3.80531 5.39499 3.80531 5.43648V9.92794C3.80409 10.1561 3.92613 10.3679 4.12443 10.4808L8.87094 13.221L7.22775 14.1698C7.21128 14.1808 7.19053 14.1827 7.17223 14.1747L3.24152 11.9037C1.4946 10.892 0.895414 8.65696 1.90219 6.90699L1.9028 6.90638ZM15.4034 10.0481L10.6569 7.30726L12.3001 6.35906C12.3166 6.34808 12.3373 6.34625 12.3556 6.35418L16.2863 8.6234C18.0363 9.63445 18.6361 11.8732 17.625 13.6231C17.1973 14.3639 16.5237 14.9313 15.7213 15.2267V10.601C15.7231 10.3728 15.6017 10.1616 15.404 10.0481H15.4034ZM17.0387 7.58672C17.01 7.56903 16.9593 7.53852 16.9233 7.51777L13.0353 5.27235C12.8383 5.15703 12.5942 5.15703 12.3965 5.27235L7.64999 8.01323V6.1156C7.64877 6.09608 7.65792 6.07716 7.67318 6.06496L11.6033 3.79757C13.3539 2.78774 15.592 3.38876 16.6012 5.13994C17.0277 5.87947 17.1821 6.7453 17.0374 7.58672H17.0387ZM6.7567 10.9689L5.11291 10.0201C5.09521 10.0115 5.08362 9.99445 5.08118 9.97493V5.43587C5.0824 3.41499 6.72192 1.7773 8.7428 1.77852C9.59765 1.77852 10.425 2.07872 11.0822 2.62543C11.0523 2.6413 11.001 2.66998 10.9669 2.69072L7.07887 4.93615C6.87996 5.04903 6.75792 5.26015 6.75914 5.48896L6.7567 10.9677V10.9689ZM7.64938 9.04442L9.76362 7.82347L11.8779 9.04381V11.4851L9.76362 12.7054L7.64938 11.4851V9.04442Z" fill="#748190" />
              </g>
              <defs>
                <clipPath id="clip0_4483_103525">
                  <rect
                    width="72" height="19.5254" fill="white"
                    transform="translate(0 0.501953)"
                  />
                </clipPath>
              </defs>
            </svg>-powered tool for mock interview practice with speech-to-text.
          </p>
          <p class="text">
            No more rambling or being caught off-guard by unexpected interview questions.<br>
            Our customized HR and technical interview simulator with instant feedback helps you overcome interview anxiety and ensures you stand out in your next job interview.
          </p>
          <a href="interviewace/" class="btn-primary">Start Interview Now</a>
        </div>
        <div class="hero-image">
          <img src="../assets/images/interview/interview-hero-img-2.webp" alt="Laptop image">
          <div v-show="showHeroSkills" class="hero-skills-wrapper parallax-delayed">
            <div class="swiper-container-skiils">
              <div class="swiper-wrapper">
                <div class="skill-item swiper-slide">
                  <div class="skill-name">
                    Role-related Knowledge
                  </div>
                  <div class="skill-level">
                    <div class="skill-bars">
                      <div class="skill-bar filled" />
                      <div class="skill-bar" />
                      <div class="skill-bar" />
                    </div>
                    <div class="skill-labels">
                      <div class="skill-bar">
                        Unfamiliar
                      </div>
                      <div class="skill-bar">
                        Basic Idea
                      </div>
                      <div class="skill-bar">
                        Expert
                      </div>
                    </div>
                  </div>
                </div>
                <div class="skill-item swiper-slide">
                  <div class="skill-name">
                    Problem-solving
                  </div>
                  <div class="skill-level">
                    <div class="skill-bars">
                      <div class="skill-bar filled-blue" />
                      <div class="skill-bar filled-blue" />
                      <div class="skill-bar filled-blue" />
                    </div>
                    <div class="skill-labels">
                      <div class="skill-bar">
                        Reactive
                      </div>
                      <div class="skill-bar">
                        Active
                      </div>
                      <div class="skill-bar">
                        Proactive
                      </div>
                    </div>
                  </div>
                </div>
                <div class="skill-item swiper-slide">
                  <div class="skill-name">
                    Communication Skills
                  </div>
                  <div class="skill-level">
                    <div class="skill-bars">
                      <div class="skill-bar filled-yellow" />
                      <div class="skill-bar filled-yellow" />
                      <div class="skill-bar" />
                    </div>
                    <div class="skill-labels">
                      <div class="skill-bar">
                        Ineffective
                      </div>
                      <div class="skill-bar">
                        Adequate
                      </div>
                      <div class="skill-bar">
                        Articulate
                      </div>
                    </div>
                  </div>
                </div>
                <div class="skill-item swiper-slide">
                  <div class="skill-name">
                    Role-related Knowledge
                  </div>
                  <div class="skill-level">
                    <div class="skill-bars">
                      <div class="skill-bar filled-blue" />
                      <div class="skill-bar filled-blue" />
                      <div class="skill-bar filled-blue" />
                    </div>
                    <div class="skill-labels">
                      <div class="skill-bar">
                        Low
                      </div>
                      <div class="skill-bar">
                        High
                      </div>
                      <div class="skill-bar">
                        Medium
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination" />
            </div>
          </div>
          <div v-show="showElementAfterOneSecond" class="candidate-avatar-wrapper parallax-delayed">
            <div class="candidate-score">
              <p class="score">
                <span class="count">4</span>/10
              </p>
              <p class="overall">
                <span class="desktop">
                  Overall Score
                </span>
                <span class="phone">
                  Score
                </span>
              </p>
            </div>
            <svg
              width="170" height="170" viewBox="0 0 250 250"
              class="circular-progress"
            >
              <circle class="bg" />
              <circle class="fg" />
            </svg>
          </div>
          <img
            v-show="showElementAfterOneSecond" src="../assets/images/interview/techs-icons/python-hero.webp" class="python-icon"
            alt="Python language icon."
          >
          <img
            v-show="showElementAfterOneSecond" src="../assets/images/interview/techs-icons/r-hero.webp" class="r-icon"
            alt="R language icon."
          >
        </div>
      </div>
    </section>

    <!-- Logo section -->
    <section class="logo-section anim-block">
      <div class="title-wrap">
        <h2 class="anim-elem">
          Practice Interviews for Top-Tier Companies
        </h2>
        <p class="anim-elem">
          Are you seeking to land a job with top-tier companies like Amazon, Meta, Google, or Apple? Our AI-powered interview prep tool trains you with an extensive library of questions taken directly from the interview process of 55 leading organizations.
        </p>
      </div>
      <div class="slider-gallery anim-elem">
        <div class="slides">
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Boston_Consulting_Group-2.svg" alt="Boston Consulting Group">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Dell_Technologies-2.svg" alt="Dell Technologies">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Guidehouse-2.svg" alt="Guidehouse">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Intel_Corporation-2.svg" alt="Intel Corporation">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McDonalds-2.svg" alt="McDonald's">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon_Web_Services-2.svg" alt="Amazon Web Services">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Bank_of_America-2.svg" alt="Bank of America">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Capital_one-2.svg" alt="Capital One">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-JPMorgan_Chase_and_Co-2.svg" alt="JPMorgan Chase & Co">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McKinsey_and_Company-2.svg" alt="McKinsey & Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-NVIDA-2.svg" alt="NVIDIA">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Boston_Consulting_Group-2.svg" alt="Boston Consulting Group">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Dell_Technologies-2.svg" alt="Dell Technologies">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Guidehouse-2.svg" alt="Guidehouse">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Intel_Corporation-2.svg" alt="Intel Corporation">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McDonalds-2.svg" alt="McDonald's">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon_Web_Services-2.svg" alt="Amazon Web Services">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Bank_of_America-2.svg" alt="Bank of America">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Capital_one-2.svg" alt="Capital One">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-JPMorgan_Chase_and_Co-2.svg" alt="JPMorgan Chase & Co">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McKinsey_and_Company-2.svg" alt="McKinsey & Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-NVIDA-2.svg" alt="NVIDIA">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Boston_Consulting_Group-2.svg" alt="Boston Consulting Group">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Dell_Technologies-2.svg" alt="Dell Technologies">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Guidehouse-2.svg" alt="Guidehouse">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Intel_Corporation-2.svg" alt="Intel Corporation">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McDonalds-2.svg" alt="McDonald's">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon_Web_Services-2.svg" alt="Amazon Web Services">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Bank_of_America-2.svg" alt="Bank of America">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Capital_one-2.svg" alt="Capital One">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-JPMorgan_Chase_and_Co-2.svg" alt="JPMorgan Chase & Co">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-McKinsey_and_Company-2.svg" alt="McKinsey & Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-NVIDA-2.svg" alt="NVIDIA">
          </div>
        </div>
      </div>
      <div class="slider-gallery">
        <div class="slides">
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Spotify-2.svg" alt="Spotify">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-T-Mobile-2.svg" alt="T-Mobile">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walmart_Global_Tech-2.svg" alt="Walmart Global Technology">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon-2.svg" alt="Amazon">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Ford_Motor_Company-2.svg" alt="Ford Motor Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Humna-2.svg" alt="Humana">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Kaiser_Permanente-2.svg" alt="Kaiser Permanente">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walt_Disney_Company-2.svg" alt="Walt Disney Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-American_express-2.svg" alt="American Express">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Booz_Allen_Hamilton-2.svg" alt="Booz Allen Hamilton">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Cisco_Systems-2.svg" alt="Cisco Systems">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-UnitedHealth_Group-2.svg" alt="UnitedHealth Group">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Spotify-2.svg" alt="Spotify">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-T-Mobile-2.svg" alt="T-Mobile">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walmart_Global_Tech-2.svg" alt="Walmart Global Technology">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon-2.svg" alt="Amazon">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Ford_Motor_Company-2.svg" alt="Ford Motor Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Humna-2.svg" alt="Humana">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Kaiser_Permanente-2.svg" alt="Kaiser Permanente">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walt_Disney_Company-2.svg" alt="Walt Disney Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-American_express-2.svg" alt="American Express">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Booz_Allen_Hamilton-2.svg" alt="Booz Allen Hamilton">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Cisco_Systems-2.svg" alt="Cisco Systems">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-UnitedHealth_Group-2.svg" alt="UnitedHealth Group">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Spotify-2.svg" alt="Spotify">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-T-Mobile-2.svg" alt="T-Mobile">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walmart_Global_Tech-2.svg" alt="Walmart Global Technology">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Amazon-2.svg" alt="Amazon">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Ford_Motor_Company-2.svg" alt="Ford Motor Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Humna-2.svg" alt="Humana">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Kaiser_Permanente-2.svg" alt="Kaiser Permanente">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Walt_Disney_Company-2.svg" alt="Walt Disney Company">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-American_express-2.svg" alt="American Express">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Booz_Allen_Hamilton-2.svg" alt="Booz Allen Hamilton">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-Cisco_Systems-2.svg" alt="Cisco Systems">
          </div>
          <div class="img-wrapper">
            <img src="../assets/images/interview/logos/interview-UnitedHealth_Group-2.svg" alt="UnitedHealth Group">
          </div>
        </div>
      </div>
    </section>

    <div ref="scroller" class="scroller">
      <section class="pin-section">
        <div class="image-text slide-1">
          <div class="text-left anim-block">
            <div class="text-left-m anim-elem">
              <h2>Prepare for <span class="blue">ANY JOB</span> in the data science world!</h2>
              <p class="text-left-par">
                Are you aspiring to become a data architect or dreaming of a machine learning engineer career? Unsure of typical data scientist interview questions?
              </p>
              <p class="text-left-par">
                Our job interview simulator prepares you for 10 data science careers across 20+ industries. Simply select your desired role, begin the mock interview, and let InterviewAce coach you.
              </p>
              <a href="interviewace/" class="btn-primary">Start Interview Prep</a>
            </div>
          </div>
          <div class="image-right mobile-only">
            <img src="../assets/images/interview/interview-laptop.webp" alt="Laptop with blank screen.">
            <div class="nested-image first anim-block">
              <img src="../assets/images/interview/interview-laptop-any-job.webp" alt="Roles you aspire to work." class="anim-elem">
            </div>
          </div>
        </div>

        <div class="image-text slide-2">
          <div class="text-left anim-block">
            <div class="text-left-m anim-elem">
              <h2>HR or Technical? <br> <span class="blue">BOTH!</span></h2>
              <p class="text-left-par">
                With a comprehensive database of HR and technical questions, InterviewAce equips you with the skills and confidence to tackle even the most challenging situations.
              </p>
              <div class="accordion">
                <div class="accordion-item" :class="{ active: activeAccordionItem === 'first' }" @click="setActiveAccordionItem('first')">
                  <div class="accordion-header">
                    HR Interview
                    <svg
                      width="20" height="20" viewBox="0 0 20 20"
                      fill="none" xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="accordion-content">
                    <p>
                      Your responses to behavioral and situational questions reveal your job compatibility. Discover techniques to showcase your strengths, navigate challenging questions, and excel in answering brainteasers.
                    </p>
                  </div>
                </div>
                <div class="accordion-item" :class="{ active: activeAccordionItem === 'second' }" @click="setActiveAccordionItem('second')">
                  <div class="accordion-header">
                    Technical Interview
                    <svg
                      width="20" height="20" viewBox="0 0 20 20"
                      fill="none" xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="accordion-content">
                    <p>
                      Build your confidence with interview practice that mirrors real-world scenarios. Answer role-specific technical questions and complete Python, R, or SQL coding tasks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="image-right mobile-only">
            <img src="../assets/images/interview/interview-laptop.webp" alt="Laptop with blank screen.">
            <div v-show="activeAccordionItem === 'first'" ref="firstImage" class="nested-image anim-block">
              <img src="../assets/images/interview/interview-laptop-hr.webp" class="anim-elem" alt="Professional experience description example.">
            </div>
            <div v-show="activeAccordionItem === 'second'" ref="secondImage" class="nested-image anim-block">
              <img src="../assets/images/interview/interview-laptop-technical.webp" class="anim-elem" alt="Database searching example.">
            </div>
          </div>
        </div>

        <div class="image-text slide-3">
          <div class="text-left bg-heading-el">
            <div class="text-left-m">
              <h2 class="relative">
                “Talk is cheap.<span class="blue"><br> Show Me The Code</span>.”
                <img class="tech-icon tech-icon-python" src="../assets/images/interview/techs-icons/ds-is-icon-python-scroll.webp" alt="Python language icon">
              </h2>
              <h3 class="sub-heading">
                Linus Torvalds
              </h3>
              <p class="text-left-par relative">
                Challenge your coding and database skills with our built-in coding compiler. Solve real-world problems in Python, R, and SQL and test your code in an interactive environment before submitting your interview answer.
                <img class="tech-icon tech-icon-sql" src="../assets/images/interview/techs-icons/ds-is-icon-sql-scroll.webp" alt="SQl lite icon.">
              </p>
            </div>
            <img class="tech-icon tech-icon-r" src="../assets/images/interview/techs-icons/ds-is-icon-r-scroll.webp" alt="R language icon.">
          </div>
          <div class="image-right mobile-only">
            <img src="../assets/images/interview/interview-laptop.webp" alt="Laptop with blank screen.">
            <div class="nested-image anim-block">
              <img src="../assets/images/interview/interview-laptop-compiler.webp" alt="Sql searching." class="anim-elem">
            </div>
          </div>
        </div>

        <div class="image-text slide-4">
          <div class="text-left">
            <div class="text-left-m">
              <h2>Get Instant <br><span class="blue">AI-POWERED</span> Feedback</h2>
              <p class="text-left-par">
                Enhance your interview preparation with instant, AI-driven feedback that pinpoints your strengths and improvement areas after each session. Receive concise, actionable advice to refine your abilities, ensuring you're well-prepared and confident for your upcoming interview.
              </p>
              <a href="interviewace/" class="btn-primary">Practice Now</a>
            </div>
          </div>
          <div class="image-right mobile-only">
            <img src="../assets/images/interview/interview-laptop.webp" alt="Laptop with blank screen.">
            <div class="nested-image anim-block">
              <img src="../assets/images/interview/interview-laptop-result-cut.webp" alt="Interview report." class="anim-elem">
            </div>
          </div>
        </div>
      </section>
      <div class="bg-scroller anim-block">
        <img
          v-for="img in bgScrollerImages" :key="img" class="bg-image"
          :class="[img, { active: img === scrollImage }]"
          :src="require(`../assets/images/interview/${img}.webp`)"
          :alt="img"
        >
        <img class="bg-placeholder" src="../assets/images/interview/interview-laptop.webp" alt="Laptop with a blank screen.">
      </div>
    </div>

    <!-- Video section -->
    <section class="video-section anim-block">
      <div class="title-wrap">
        <h2 class="anim-elem">
          Boost Your Job Prospects with InterviewAce
        </h2>
        <p class="anim-elem">
          Perfect your skills with the only AI-powered interview simulator that offers both HR and technical questions in one comprehensive tool.
        </p>
      </div>

      <div class="container video-player-wrapper anim-block">
        <VideoPlayer
          v-if="videoJSLoaded" slot="player"
          :video-id="'6363236691112'" class="col-10 video-player anim-elem"
        />
      </div>
      <div class="video-info-wrapper anim-block">
        <h3 class="video-info-heading anim-elem">
          Train with authentic interview questions for
        </h3>

        <div class="video-info anim-elem">
          <div class="video-info-box">
            <span class="separator anim-elem first" />
            <h3 class="fs-57" data-target="10">
              0
            </h3>
            <p>Data Science Roles</p>
          </div>
          <div class="video-info-box anim-elem">
            <h3 class="fs-57" data-target="20">
              0
            </h3>
            <p>Industries</p>
          </div>
          <div class="video-info-box anim-elem">
            <span class="separator anim-elem second" />
            <h3 class="fs-57" data-target="55">
              0
            </h3>
            <p>Leading Companies</p>
          </div>
        </div>
      </div>
    </section>

    <section class="how-it-work anim-block">
      <h2 class="anim-elem">
        How Does <span class="blue">InterviewAce</span> Work?
      </h2>

      <div class="container anim-elem">
        <div class="track-line">
          <div class="track-line-filler" />
        </div>
        <div class="tracker">
          <div v-for="k in trackerData" :key="k.number" class="col-12 anim-elem">
            <div class="col-6 sm-6">
              <div class="col-10 sm-9 sm-offset-1 offset-1 col track">
                <div class="h3">
                  {{ k.number }}
                </div>
                <div>
                  <span class="h5">
                    {{ k.title }}
                  </span>
                  <br>
                  <span class="body-1">
                    {{ k.description }}
                  </span>
                </div>
              </div>
              <div class="track-dot" />
            </div>
          </div>
        </div>
      </div>
      <div class="how-it-work-btn anim-elem">
        <a href="interviewace/" class="btn-primary track-button">Start Interview Now</a>
      </div>
      <div class="what-will-you-get anim-block">
        <h2 class="anim-elem">
          What will you gain?
        </h2>
        <div class="benefit-wrapper container">
          <div class="row">
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M23.3327 14.8281V8.17813C23.3327 6.21794 23.3327 5.23785 22.9512 4.48916C22.6156 3.83059 22.0802 3.29516 21.4217 2.9596C20.673 2.57812 19.6929 2.57812 17.7327 2.57812H10.266C8.30583 2.57812 7.32574 2.57812 6.57705 2.9596C5.91848 3.29516 5.38305 3.83059 5.04749 4.48916C4.66602 5.23785 4.66602 6.21794 4.66602 8.17813V20.3115C4.66602 22.2716 4.66602 23.2517 5.04749 24.0004C5.38305 24.659 5.91848 25.1944 6.57705 25.53C7.32574 25.9115 8.30583 25.9115 10.266 25.9115H13.9993M16.3327 13.0781H9.33268M11.666 17.7448H9.33268M18.666 8.41146H9.33268M16.916 22.4115L19.2493 24.7448L24.4994 19.4948" stroke="white" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <div class="right-side">
                <h3>
                  Know What to Expect and Prepare
                </h3>
                <p>Understand the standard interview questions and scenarios, ensuring you're always one step ahead in your preparation.</p>
              </div>
            </div>
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M18.6667 11.328H8M16.6667 15.4113H8.5M14 24.7446C8.20101 24.7446 3.5 20.0436 3.5 14.2446C3.5 8.44564 8.20101 3.74463 14 3.74463C19.799 3.74463 24.5 8.44564 24.5 14.2446C24.5 15.6413 24.2273 16.9743 23.7323 18.1932C23.6375 18.4265 23.5901 18.5432 23.569 18.6375C23.5483 18.7297 23.5408 18.798 23.5408 18.8925C23.5407 18.9891 23.5583 19.0944 23.5934 19.3049L24.2852 23.4557C24.3576 23.8904 24.3939 24.1078 24.3264 24.2649C24.2674 24.4025 24.1578 24.5121 24.0203 24.5711C23.8631 24.6385 23.6458 24.6023 23.2111 24.5298L19.0602 23.838C18.8497 23.8029 18.7445 23.7854 18.6478 23.7854C18.5533 23.7854 18.4851 23.793 18.3928 23.8136C18.2985 23.8348 18.1819 23.8821 17.9486 23.9769C16.7296 24.4719 15.3967 24.7446 14 24.7446Z" stroke="white" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <div class="right-side">
                <h3>
                  Master Response Delivery
                </h3>
                <p>Learn to deliver responses with clarity, confidence, and appropriate tone, making a lasting impression on your interviewers.</p>
              </div>
            </div>
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M22.1673 11.9115V14.2448C22.1673 18.7551 18.511 22.4115 14.0007 22.4115M5.83398 11.9115V14.2448C5.83398 18.7551 9.49033 22.4115 14.0007 22.4115M14.0007 22.4115V25.9115M9.33398 25.9115H18.6673M14.0007 17.7448C12.0677 17.7448 10.5007 16.1778 10.5007 14.2448V6.07812C10.5007 4.14513 12.0677 2.57812 14.0007 2.57812C15.9336 2.57812 17.5007 4.14513 17.5007 6.07813V14.2448C17.5007 16.1778 15.9336 17.7448 14.0007 17.7448Z" stroke="white" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <div class="right-side">
                <h3>
                  Boost Your Speaking Confidence
                </h3>
                <p>Immerse yourself in a realistic interview simulation using the speech-to-text feature to practice and improve your verbal responses.</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M14.6023 2.57812L4.74423 15.0473C4.35816 15.5356 4.16512 15.7798 4.16217 15.986C4.15961 16.1653 4.23539 16.3358 4.36769 16.4485C4.51987 16.5781 4.8214 16.5781 5.42446 16.5781H13.4954L12.3886 25.9115L22.2467 13.4423C22.6327 12.954 22.8258 12.7098 22.8287 12.5036C22.8313 12.3243 22.7555 12.1538 22.6232 12.0411C22.471 11.9115 22.1695 11.9115 21.5664 11.9115H13.4954L14.6023 2.57812Z" fill="url(#paint0_linear_4989_15801)" stroke="white"
                  stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_4989_15801" x1="13.4954" y1="2.57812"
                    x2="13.4954" y2="25.9115" gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.525" stop-color="white" stop-opacity="0" />
                    <stop offset="0.5251" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>
              <div class="right-side">
                <h3>
                  Practice Anytime, Anywhere, for Free
                </h3>
                <p>Enjoy a flexible and convenient mock interview practice tool with two free-of-charge sessions per day.</p>
              </div>
            </div>
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M18.6673 9.57813V6.07813L22.1673 2.57812L23.3339 4.91146L25.6673 6.07813L22.1673 9.57813H18.6673ZM18.6673 9.57813L14.0006 14.2447M25.6673 14.2448C25.6673 20.6881 20.444 25.9115 14.0007 25.9115C7.55733 25.9115 2.33398 20.6881 2.33398 14.2448C2.33398 7.80147 7.55733 2.57812 14.0007 2.57812M19.834 14.2448C19.834 17.4665 17.2223 20.0781 14.0007 20.0781C10.779 20.0781 8.16732 17.4665 8.16732 14.2448C8.16732 11.0231 10.779 8.41146 14.0007 8.41146" stroke="white" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <div class="right-side">
                <h3>
                  Prepare for Your Dream Job
                </h3>
                <p>Benefit from a customized experience tailored to your desired role, industry demands, and company culture and expectations.</p>
              </div>
            </div>
            <div class="benefit-box col col-4 anim-elem">
              <svg
                xmlns="http://www.w3.org/2000/svg" width="28" height="29"
                viewBox="0 0 28 29" fill="none"
              >
                <path
                  d="M18.6673 8.4113C18.6673 7.32633 18.6673 6.78385 18.5481 6.33876C18.2244 5.13094 17.281 4.18752 16.0732 3.86389C15.6281 3.74463 15.0856 3.74463 14.0007 3.74463C12.9157 3.74463 12.3732 3.74463 11.9281 3.86389C10.7203 4.18752 9.77688 5.13094 9.45324 6.33876C9.33398 6.78385 9.33398 7.32633 9.33398 8.4113M6.06732 24.7446H21.934C23.2408 24.7446 23.8942 24.7446 24.3933 24.4903C24.8323 24.2666 25.1893 23.9097 25.413 23.4706C25.6673 22.9715 25.6673 22.3181 25.6673 21.0113V12.1446C25.6673 10.8378 25.6673 10.1844 25.413 9.68532C25.1893 9.24627 24.8323 8.88932 24.3933 8.66561C23.8942 8.4113 23.2408 8.4113 21.934 8.4113H6.06732C4.76053 8.4113 4.10713 8.4113 3.60801 8.66561C3.16896 8.88932 2.81201 9.24627 2.5883 9.68532C2.33398 10.1844 2.33398 10.8378 2.33398 12.1446V21.0113C2.33398 22.3181 2.33398 22.9715 2.5883 23.4706C2.81201 23.9097 3.16896 24.2666 3.60801 24.4903C4.10713 24.7446 4.76053 24.7446 6.06732 24.7446Z" stroke="white" stroke-width="2.33333"
                  stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <div class="right-side">
                <h3>
                  Get Hired Faster
                </h3>
                <p>Save yourself time and reduce the number of rejections by gaining the skills and confidence to stand out in interviews.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section container anim-block">
      <div class="row">
        <div class="col col-3 md-4 faq-text anim-elem">
          <h2>Frequently Asked Questions</h2>
          <p>
            Find the answers to common questions about InterviewAce.
          </p>
        </div>

        <div class="empty-column col col-1" />

        <div class="col col-8 faq anim-elem">
          <div class="accordion">
            <div class="accordion-item">
              <div class="accordion-header">
                How can I do a mock interview online for free?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  With InterviewAce, you can efficiently conduct a mock interview online at no cost. Sign up and enjoy two free-of-charge sessions per day. Each session provides a realistic interview experience for one of 10 data science roles with technical and HR questions tailored to your chosen company, industry, and experience level. Afterward, you'll receive instant performance feedback, helping refine your skills and approach.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                Where can I practice for a job interview?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  Interview simulators like InterviewAce allow you to practice for job interviews online. These tools offer a range of practice questions that mimic actual interviews, allowing you to prepare in a risk-free environment. With InterviewAce, you can conduct two practice interviews daily for free—tailoring them to your desired data science role, industry, and company. With the instant feedback feature, you can identify your strengths and areas for improvement and work on your interview skills.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                Which careers does InterviewAce prepare you for?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  InterviewAce offers tailored preparation for 10 data science roles: data scientist, data analyst, business analyst, business intelligence analyst, machine learning engineer, data architect, risk management analyst, tableau developer, database administrator, and data strategist. Additionally, you can select the specific company or industry you’re applying for to further customize your mock interview practice experience and ensure you're well-equipped with the knowledge and skills required for your targeted job.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                Is InterviewAce free?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  We at 365 Data Science provide you with all the resources you need to prepare for your dream job in data science—from comprehensive courses and practical exercises to data science projects and interview practice. Our interview prep tool (InterviewAce) is free to further aid your job preparation efforts. You can enjoy two mock interview sessions daily, practicing and refining your HR and technical interview skills at no cost.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                Is there an InterviewAce app available for interview practice?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  InterviewAce is an online AI-powered interview prep tool accessible through your web browser, which means you can practice for interviews on any device with internet access. While there isn't a downloadable mobile app version of InterviewAce, the web-based service ensures easy and convenient access from anywhere, at any time. To begin using InterviewAce, register on our platform to ensure a personalized, secure experience tailored to your interview preparation needs.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                How long does a typical InterviewAce interview session last?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  A typical InterviewAce interview session's duration can vary depending on several factors, including the user's response time and the complexity of the questions. At the beginning of each session, users customize their experience by choosing the interview type (technical or HR), role, level of expertise, target company or industry, and providing background information. This customization process ensures that the six questions are tailored to the user's profile.
                </p>
                <p>
                  For HR interviews, the session length primarily depends on how long the user takes to respond to each question. Users can answer by typing or using the speech-to-text feature. In technical interviews, some questions may involve coding or problem-solving within the built-in compiler, which could require additional time.
                </p>
                <p>
                  After answering all six questions, users receive personalized feedback from the platform's connection to ChatGPT. On average, a session could take 30 to 60 minutes, considering the time needed to answer questions and review the feedback provided.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                What types of questions will InterviewAce ask me?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  InterviewAce will ask you various questions tailored to the specific role, industry, and company you're targeting, as well as your expertise and background. The questions are designed to cover HR or technical aspects, depending on your chosen focus.
                </p>
                <p>
                  For HR interviews, you can expect behavioral and situational questions that assess your soft skills, problem-solving abilities, and cultural fit. These include questions about how you've handled past challenges, your teamwork experiences, or your approach to conflict resolution.
                </p>
                <p>
                  The questions will be role-specific in technical interviews—ranging from theoretical knowledge checks to practical problem-solving tasks. For example, if you're applying for a data scientist role, you might face data analysis, statistical methods, or machine learning questions. Additionally, some questions may require you to write code or solve problems using InterviewAce's built-in coding compiler, allowing you to demonstrate your practical skills in languages like Python, R, or SQL.
                </p>
                <p>
                  Overall, the tool simulates a real interview experience, helping you prepare comprehensively for various interview questions.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                What is the difference between an HR and a technical interview?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  The key difference between an HR (Human Resources) and a technical interview lies in the focus and content of the questions.
                </p>
                <p>
                  Technical interviews aim to evaluate a candidate's specific job-related skills, knowledge, and proficiency in the field or role they are applying for. They feature questions that require technical knowledge and expertise, including problem-solving tasks, coding, case studies, or theoretical questions relevant to the role.
                </p>
                <p>
                  HR interviews assess a candidate's cultural fit, soft skills, and alignment with the company's values and team dynamics. Typically, they include behavioral and situational questions that explore the candidate's previous work experiences, decision-making processes, problem-solving skills, and ability to work in a team. Examples include questions about how you handled a difficult situation at work, resolved a conflict, or demonstrated leadership.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                How does InterviewAce provide instant, personalized AI-powered feedback?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  InterviewAce provides customized feedback powered by ChatGPT and tailored to the user's provided details and target role. The feedback report features an overall performance score and detailed evaluation for each response, complete with actionable steps for improvement.
                </p>
                <p>
                  Users also receive individual scores for their role-related knowledge, problem-solving, and communication skills, as well as coding or culture fit, depending on the type of interview. This comprehensive and structured feedback aims to deliver precise and actionable insights, empowering candidates to refine their interview skills effectively.
                </p>
              </div>
            </div>

            <div class="accordion-item">
              <div class="accordion-header">
                Does InterviewAce store my data and audio files?
                <svg
                  width="20" height="20" viewBox="0 0 20 20"
                  fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 6.5L10 12.75L3.75 6.5" stroke="#000C1F" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="accordion-content">
                <p>
                  InterviewAce primarily retains user data and audio files to enhance and refine the interview simulator experience. The tool uses this information to improve algorithms, ensuring users receive increasingly accurate and personalized feedback. But it’s important to note that InterviewAce adheres to strict privacy policies to protect user information. It ensures that any data collected is used responsibly and with user consent—focusing on the tool's continuous improvement while respecting user privacy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section anim-block">
      <h2 class="anim-elem">
        Prep Now for a <span class="blue">Better Tomorrow!</span>
      </h2>
      <div class="cta-btn anim-elem">
        <a href="interviewace/" class="btn-primary">Аce Your Interview</a>
      </div>
    </section>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import VideoPlayer from '@itbpbg/lms-components/src/components/VideoPlayer.vue';

export default {
  components: {
    VideoPlayer,
  },
  mixins: [global],
  async asyncData({ $config, error }) {
    if ($config.platform === 'fa') {
      error({ statusCode: 404, message: 'Page not found' });
    }
  },
  data() {
    return {
      videoJSLoaded: false,
      activeAccordionItem: 'first',
      trackerData: [
        {
          number: '01',
          title: 'Fill in the Questionnaire',
          description: 'Customize your interview for better results by selecting or manually typing the role, company, and industry you’re applying for.',
        },
        {
          number: '02',
          title: 'Start the Mock Interview',
          description: 'Conduct self-paced practice sessions encompassing behavioral, situational, coding, database, and various HR or technical queries.',
        },
        {
          number: '03',
          title: 'Get Instant AI-Powered Feedback',
          description: 'Obtain a comprehensive, personalized performance report featuring insightful analysis and step-by-step improvement tips.',
        },
      ],
      showElementAfterOneSecond: false,
      showHeroSkills: false,
      bgScrollerImages: [
        'interview-laptop-any-job',
        'interview-laptop-hr',
        'interview-laptop-technical',
        'interview-laptop-compiler',
        'interview-laptop-result-cut',
      ],
      currentImage: 0,
    };
  },
  head() {
    const brightcoveSrc = [
      { src: 'https://players.brightcove.net/6258000438001/FHDad0Z7G_default/index.min.js' },
      { src: 'https://players.brightcove.net/videojs-quality-menu/1/videojs-quality-menu.min.js' },
    ];

    return {
      titleTemplate: 'Interview Simulator %s',
      meta: [
        { name: 'robots' },
      ],
      script: [
        { src: 'https://unpkg.com/swiper/swiper-bundle.min.js' },
        { src: 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js' },
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.9.1/gsap.min.js' },
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.9.1/ScrollTrigger.min.js' },
        ...brightcoveSrc,
      ],
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
        { rel: 'stylesheet', href: 'https://unpkg.com/swiper/swiper-bundle.min.css' },
      ],
    };
  },
  computed: {
    scrollImageAccordion() {
      if (this.activeAccordionItem === 'first') {
        return 'hr';
      }

      return 'technical';
    },
    scrollImage() {
      const images = [
        'interview-laptop-any-job',
        `interview-laptop-${this.scrollImageAccordion}`,
        'interview-laptop-compiler',
        'interview-laptop-result-cut',
      ];

      return images[this.currentImage] || '';
    },
  },
  watch: {
    activeAccordionItem() {
      this.fadeImages();
    },
  },
  async mounted() {
    await this.$pollValue(() => typeof Swiper !== 'undefined' && typeof videojs !== 'undefined');
    this.videoJSLoaded = true;

    // sliders
    const swiper = new Swiper('.swiper-container', {
      slidesPerView: 2.5,
      spaceBetween: 15,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        678: {
          slidesPerView: 8.5,
        },
      },
      speed: 1000,
      direction: 'horizontal',
      loop: true,
      centeredSlides: true,
    });
    const swiper2 = new Swiper('.swiper-container-2', {
      slidesPerView: 2.5,
      spaceBetween: 15,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        678: {
          slidesPerView: 8.5,
        },
      },
      speed: 1000,
      direction: 'horizontal',
      loop: true,
      centeredSlides: true,
    });

    setTimeout(() => {
      const swiper3 = new Swiper('.swiper-container-skiils', {
        slidesPerView: 1,
        autoplay: {
          disableOnInteraction: false,
        },
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }, 2000);

    $('.accordion-header').click(function () {
      const accordionItem = $(this).parent();
      accordionItem.toggleClass('active');
      const accordionContent = accordionItem.find('.accordion-content');
      accordionContent.slideDown();
      if (accordionItem.hasClass('active')) {
        accordionContent.slideDown();
      } else {
        accordionContent.slideUp();
      }
    });

    if ($(window).width() <= 1024) {
      const mySwiper = new Swiper('.swiper-container-slide-mobile', {
        slidesPerView: 0.8,
        loop: true,
      });
    }

    // animations
    let count = 1;
    const countdownElement = $('.count');

    function countdown() {
      if (count <= 4) {
        countdownElement.text(count);
        count++;
        setTimeout(countdown, 200);
      }
    }
    countdown();

    gsap.registerPlugin(ScrollTrigger);

    // Moving icons effect
    const scrollTriggerHeroOptions = {
      scrollTrigger: {
        trigger: '.parallax-trigger',
        start: 'top top+=80px',
        scrub: true,
      },
    };
    gsap.fromTo('.r-icon', {
      ...scrollTriggerHeroOptions,
      y: 0,
    }, {
      ...scrollTriggerHeroOptions,
      y: -100,
    });
    gsap.fromTo('.python-icon', {
      ...scrollTriggerHeroOptions,
      y: 0,
    }, {
      ...scrollTriggerHeroOptions,
      y: -150,
    });
    gsap.fromTo('.candidate-avatar-wrapper', {
      ...scrollTriggerHeroOptions,
      top: '+=0',
    }, {
      ...scrollTriggerHeroOptions,
      top: '+=-50',
      delay: 0.2,
    });
    gsap.fromTo('.hero-skills-wrapper', {
      ...scrollTriggerHeroOptions,
      bottom: '+=0',
    }, {
      ...scrollTriggerHeroOptions,
      bottom: '+=100',
      delay: 0.2,
    });
    gsap.fromTo('.tech-icon', {
      scrollTrigger: {
        trigger: '.bg-heading-el',
        start: 'top top+=80%',
        scrub: true,
      },
      y: 0,
    }, {
      scrollTrigger: {
        trigger: '.bg-heading-el',
        start: 'top top+=80%',
        scrub: true,
      },
      y: -120,
    });

    $(document).ready(() => {
      gsap.utils.toArray('.anim-block').forEach((elem) => {
        gsap.utils.toArray(elem.querySelectorAll('.anim-elem')).forEach((innerElem) => {
          const from = {
            opacity: 0,
            y: 10,
          };

          const to = {
            opacity: 1,
            y: 0,
            duration: 0.5,
            scrollTrigger: {
              trigger: innerElem,
              start: 'top 90%',
              end: 'top 100%',
              toggleActions: 'play none reverse none',
            },
          };

          gsap.fromTo(innerElem, from, to);
        });
      });
    });

    // Show candidate-avatar-wrapper after a delay
    setTimeout(() => {
      this.showElementAfterOneSecond = true;
    }, 1000);

    // Show hero-skills-wrapper after a delay
    setTimeout(() => {
      this.showHeroSkills = true;
    }, 1600);

    // Counter animation
    const counters = document.querySelectorAll('.fs-57');

    const counterAnimationIntersectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          const updateCount = () => {
            const target = +counter.getAttribute('data-target');
            const currentCount = +counter.innerText;

            const increment = target / 200;

            if (currentCount < target) {
              counter.innerText = Math.ceil(currentCount + increment);
              setTimeout(updateCount, 30);
            } else {
              counter.innerText = target === 20 ? `${target}+` : target;
            }
          };

          updateCount();
          observer.unobserve(counter); // Stop observing once the animation is done
        }
      });
    }, {
      threshold: 0.1,
    });

    counters.forEach((counter) => {
      counterAnimationIntersectionObserver.observe(counter);
    });

    this.scrollAnimation();
    window.addEventListener('scroll', this.scrollAnimation);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', this.scrollAnimation));
  },
  methods: {
    scrollAnimation() {
      // Laptop scroll effect
      const { scroller } = this.$refs;
      if (scroller) {
        const scrollerBound = scroller.getBoundingClientRect();
        const { height, top, bottom } = scrollerBound;
        const topStart = (window.innerHeight - 80) * 0.2;

        if (top > topStart) {
          this.currentImage = 0;
        } else if (top < topStart) {
          const scrollPercentage = (window.innerHeight - top + topStart) / height;
          this.currentImage = Math.floor(scrollPercentage * 4) - 1;
        } else if (top > window.innerHeight) {
          this.currentImage = 0;
        } else if (bottom < 0) {
          this.currentImage = 4;
        } else {
          this.currentImage = 0;
        }

        if (this.currentImage < 0) {
          this.currentImage = 0;
        }
      }

      // Timeline scroll effect
      const dots = this.$el.querySelectorAll('.track-dot');
      const lineFiller = this.$el.querySelector('.track-line .track-line-filler');
      const button = this.$el.querySelector('.track-button');
      const buttonBound = button.getBoundingClientRect();
      const startPositionY = window.innerHeight * 0.5;

      if (lineFiller.getBoundingClientRect().y < startPositionY) {
        lineFiller.style.height = `${startPositionY - lineFiller.getBoundingClientRect().y}px`;
        dots.forEach((dot) => {
          const dotBound = dot.getBoundingClientRect();
          if (dotBound.top - startPositionY < 0) {
            dot.classList.add('filled');
          } else {
            dot.classList.remove('filled');
          }
        });
      } else {
        dots[0].classList.remove('filled');
        lineFiller.style.height = '0px';
      }

      if (buttonBound.y - startPositionY < 0) {
        button.classList.add('filled');
      } else {
        button.classList.remove('filled');
      }
    },
    setActiveAccordionItem(item) {
      this.activeAccordionItem = item;
    },
    fadeImages() {
      const { firstImage } = this.$refs;
      const { secondImage } = this.$refs;

      if (this.activeAccordionItem === 'first') {
        gsap.to(secondImage, { opacity: 0, duration: 0.5 });
        gsap.to(firstImage, { opacity: 1, duration: 0.5 });
      } else {
        gsap.to(firstImage, { opacity: 0, duration: 0.5 });
        gsap.to(secondImage, { opacity: 1, duration: 0.5 });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.hero {
  background-image: url("../assets/images/interview/interview-hero-landing.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  animation: fadeInAnimation 0.2s ease-in forwards;
  padding: var(--spacing-80) 0 var(--spacing-36);
}

@include bp($bp-desktop) {
  .mobile-only {
    display: none !important;
  }
}

@include bp($bp-mobile) {
  .hero {
    background-image: url("../assets/images/interview/interview-hero-mobile.png");
  }
}

@include bp($bp-phone) {
  .hero {
    padding: 68px 0 var(--spacing-90);
  }
}

.hero-wrapper {
  display: flex;
  padding: 0 135px;
  gap: var(--spacing-30);
}
@include bp($bp-mobile) {
  .hero-wrapper {
    flex-direction: column-reverse;
  }
}
@include bp($bp-phone) {
  .hero-wrapper {
    padding: 0 var(--spacing-24);
  }
}

.hero-text {
  width: 100%;
  max-width: 470px;
  align-self: center;
  opacity: 0;
  animation: fadeInAnimation 0.5s ease-in forwards;
}

@include bp($bp-mobile) {
  .hero-text {
    width: 100%;
    padding-top: 0;
    text-align: center;
    margin-top: var(--spacing-60);
  }
}
.hero-text h1 {
  font-size: 52px;
  color: #3dafb8;
  text-transform: uppercase;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 0;
}
@include bp($bp-phone) {
  .hero-text h1 {
    font-size: 40px;
  }
}
.hero-text h1 span {
  font-weight: 800;
}
.hero-text h2 {
  font-size: 32px;
  color: var(--main-light);
  margin-bottom: 10px;
  font-weight: 500;
  white-space: nowrap;
}
@include bp($bp-laptop) {
  .hero {
    .hero-wrapper {
      padding: 0 108px;

      .hero-text {
        h2 {
          font-size: 24px;
        }

        h1 {
          font-size: 44px;
        }
      }
    }
  }
}
@include bp($bp-phone) {
  .hero-text h2 {
    font-size: 24px;
  }
}
.hero-text .sub-heading {
  color: #748190;
  margin: 0 0 var(--spacing-20);
}
@include bp($bp-phone) {
  .hero-text .sub-heading {
    display: block;
  }
}
.hero-text .sub-heading svg {
  vertical-align: middle;
}
.hero-text .text {
  margin: 0 0 var(--spacing-22);
  line-height: 150%;
  color: var(--main-light-shade-2);
}
@include bp($bp-phone) {
  .hero-text .text {
    font-size: 18px;
    padding-right: 0;
    margin-bottom: var(--spacing-20);
  }
}

.hero-image {
  position: relative;
  width: 100%;

  .python-icon,
  .r-icon {
    position: absolute;
  }

  .python-icon {
    width: 66px;
    top: 10vw;
    left: 0;

    @include bp($bp-mobile) {
      top: 2vw;
      right: 0;
      bottom: 2vw;
    }
  }

  .r-icon {
    width: 77px;
    right: 3vw;
    bottom: 7vw;

    @include bp($bp-mobile) {
      right: 0;
      bottom: 2vw;
    }
  }
}
@include bp($bp-mobile) {
  .hero-image {
    width: 100%;
    margin-top: 0;
  }
}

@include bp($bp-phone) {
  .hero-image {
    .python-icon,
    .r-icon {
      width: 40px;
    }

    .python-icon {
      top: 4vw;
      left: 3vw;
    }

    .r-icon {
      right: 3vw;
    }
  }
}

.hero-image img {
  &:not(.python-icon):not(.r-icon) {
    width: 100%;
  }

  animation: fadeInAnimation 0.5s ease-in forwards;
}
.hero-image .candidate-avatar-wrapper {
  position: absolute;
  top: 7vw;
  right: 5vw;
  background: var(--main-light);
  border-radius: 10px;
  padding: 0.8vw 1.2vw;
  box-shadow: 0 0 18px -3px #68696e;
  margin: 0;
  animation: scaleAnimation 0.5s forwards;
}
.hero-image .candidate-avatar-wrapper svg {
  height: unset;
  width: 6vw;
}
@include bp($bp-mobile) {
  .hero-image .candidate-avatar-wrapper svg {
    width: 100px;
  }
}

@include bp($bp-phone) {
  .hero-image .candidate-avatar-wrapper {
    top: -3vw;
    right: 3vw;
    padding: 7px var(--spacing-14);

    svg {
      width: 66px;
    }

    .candidate-score .score {
      font-size: 14px;
    }

    .overall {
      .desktop {
        display: none;
      }

      .phone {
        display: inline;
        font-weight: 500;
        color: var(--main-dark);
      }
    }
  }
}

.hero-image .candidate-avatar-wrapper .candidate-score {
  color: #000;
}
.hero-image .candidate-avatar-wrapper .score {
  font-size: 21px;
}
.hero-image .candidate-avatar-wrapper .overall {
  font-size: 9px;
  margin: 0;
}
.hero-image .candidate-avatar-wrapper .circular-progress circle.bg {
  stroke: #abafb5;
}

.btn-primary {
  width: 100%;
  max-width: 350px;
  font-size: 21px;
  font-weight: 600;
  margin-top: 10px;
  padding: 21px 19px;

  &.z-index {
    position: relative;
    z-index: 10;
  }
}

@include bp($bp-laptop) {
  .btn-primary {
    max-width: 310px;
  }
}

.swiper-container,
.swiper-container-2 {
  overflow: hidden;
}

.logo-section {
  position: relative;
  overflow: hidden;
  padding-top: 60px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 135px;
    height: 100%;
    z-index: 1;
  }

  &:before {
    left: 0;
    background: linear-gradient(90deg, #FFF 0.28%, rgba(255, 255, 255, 0.00) 95.28%);
  }

  &:after {
    right: 0;
    background: linear-gradient(270deg, #FFF 0.28%, rgba(255, 255, 255, 0.00) 95.28%);
  }
}

@include bp($bp-laptop) {
  .logo-section {
    padding-bottom: var(--spacing-80);

    &:before,
    &:after {
      width: 145px;
    }
  }
}

@include bp($bp-mobile) {
  .logo-section {
    margin-bottom: 80px;
  }
}

@include bp($bp-phone) {
  .logo-section {
    &:before,
    &:after {
      content: none;
    }

    .slider-gallery {
      position: relative;

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 0;
        width: 30px;
        height: 100%;
        z-index: 1;
      }

      &:before {
        left: 0;
        background: linear-gradient(90deg, #FFF 0.28%, rgba(255, 255, 255, 0.00) 95.28%);
      }

      &:after {
        right: 0;
        background: linear-gradient(270deg, #FFF 0.28%, rgba(255, 255, 255, 0.00) 95.28%);
      }
    }
  }
}

.title-wrap {
  margin: 0 auto;
  text-align: center;
  padding: 0 135px 30px;
}
@include bp($bp-phone) {
  .title-wrap {
    padding: 0 var(--spacing-24);
  }
}
.title-wrap h2 {
  font-weight: 500;
  font-size: 40px;
  margin-bottom: var(--spacing-16);
  margin-top: 0;
}
.title-wrap p {
  font-size: 21px;
  margin: 0 0 var(--spacing-10);
}

@include bp($bp-laptop) {
  .title-wrap {
    h2 {
      font-size: 32px;
    }

    p {
      font-size: 21px;
    }
  }
}

@include bp($bp-phone) {
  .title-wrap {
    h2 {
      font-size: 32px;
    }

    p {
      font-size: 21px;
      margin-bottom: var(--spacing-30);
    }
  }
}

.video-section {
  padding: var(--spacing-100) 0;

  .video-player-wrapper {
    display: flex;
    justify-content: center;
    margin-top: var(--spacing-32);
    margin-bottom: var(--spacing-32);
  }
}
.video-section .title-wrap {
  padding-bottom: 0;

  p {
    margin-bottom: 0;
  }
}

@include bp($bp-mobile) {
  .video-section {
    padding: var(--spacing-60) 0;

    .title-wrap {
      padding-right: var(--spacing-24);
      padding-left: var(--spacing-24);

      h2 {
        font-size: 32px;
      }

      p {
        font-size: 18px;
        line-height: 140%;
      }
    }

    .video-info-wrapper {
      .video-info-heading {
        font-size: 21px;
        margin-bottom: var(--spacing-22);
      }

      .video-info-box {
        p {
          font-size: 18px;
        }

        .separator {
          height: 96%;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .video-section {
    .video-info-wrapper {
      padding-right: var(--spacing-24);
      padding-left: var(--spacing-24);

      .video-info-heading {
        font-size: 18px
      }

      .video-info {
        width: 100%;
        flex-wrap: unset;
        gap: var(--spacing-24);
        padding: 0;

        .video-info-box {
          p {
            font-size: 16px;
          }

          &:nth-of-type(2) {
            width: 38%;
          }

          &:nth-of-type(3) {
            width: 39%;
          }

          .separator {
            height: 96%;

            &.first {
              left: calc(100% + 12px);
            }

            &.second {
              left: -12px;
            }
          }
        }
      }
    }
  }
}

.video-info-heading {
  font-size: 28px;
  text-align: center;
  color: var(--main-dark-light-1);
  font-weight: 400;
  line-height: 140%;
}

.video-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 920px;
  margin: 0 auto;
}

@include bp($bp-mobile) {
  .video-info {
    width: 100%;
    padding: 0 var(--spacing-24);
  }
}

.video-info .separator {
  position: absolute;
  top: 5px;
  height: 60%;
  width: 1px;
  background: #abafb5;

  &.first {
    left: calc(100% + 49px);
  }

  &.second {
    left: -64px;
  }
}
.video-info .video-info-box {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.video-info .fs-57 {
  font-size: 57px;
}
@include bp($bp-laptop) {
  .video-info .fs-57 {
    font-size: 54px;
  }
}

@include bp($bp-mobile) {
  .video-info .fs-57 {
    font-size: 32px;
  }
}

.video-info h3 {
  margin-bottom: 0;
  margin-top: 0;
}
.video-info p {
  font-size: 21px;
  font-weight: 500;
  line-height: 110%;
  color: #545c69;
  margin: var(--spacing-8) 0 0;
}

@include bp($bp-phone) {
  .video-info p {
    padding-top: 0;
    font-size: 18px;
  }
}

.blue {
  color: #55bfc7;
  font-weight: 600;
}

.pin-section {
  width: calc(30vw + 135px);
  padding-left: 135px;
  flex: 0 0 auto;

  @include bp($bp-laptop) {
    width: 455px;
    padding-left: 145px;
  }

  @include bp($bp-mobile) {
    width: 100%;
    padding-left: 0;
  }
}

.scroller {
  position: relative;
  display: flex;
  align-items: flex-start;

  .bg-scroller {
    flex: 1;
    max-width: 965px;
    position: sticky;
    top: calc((100vh - 80px) * 0.2);
    margin-top: 160px;
    margin-left: 32px;
    overflow: hidden;
    z-index: 1;

    @include bp($bp-laptop) {
      top: calc((100vh - 80px) * 0.25);
      margin-top: 80px;
    }

    @include bp($bp-mobile) {
      display: none;
    }

    .bg-image {
      position: absolute;
      opacity: 0;
      z-index: -1;
      transition: all 0.8s ease-in-out;

      &.interview-laptop-result-cut {
        max-width: calc(100% + 3px);
        left: -1px;
        top: 3px;

        @include bp($bp-laptop) {
          max-width: 64.3vw;
        }
      }

      &.active {
        opacity: 1;
        z-index: 1;
      }
    }

    img {
      display: block;
      max-width: 100%;

      @include bp($bp-laptop) {
        max-width: 64vw;
      }
    }
  }
}

.image-text {
  min-height: 600px;
  height: calc(90vh - 80px);
  display: flex;
  justify-content: space-between;
  max-width: calc(100vw - 17px);

  @include bp($bp-mobile) {
    height: auto;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @include bp($bp-laptop) {
    &.slide-1 {
      .text-left {
        align-items: flex-start;
        margin-top: 80px;
      }
    }
  }
}
@include bp($bp-mobile) {
  .image-text {
    padding-left: 0;
    max-width: 100%;
  }
}
.image-text .text-left {
  display: flex;
  align-items: center;
  z-index: 1;

  .btn-primary {
    width: 310px;
    padding: 23px 0 19px;
    line-height: 100%;
    margin-top: var(--spacing-30);

    @include bp($bp-mobile) {
      width: 100%;
      max-width: 375px;
    }
  }
}

@include bp($bp-laptop) {
  .image-text {
    .bg-heading-el .tech-icon.tech-icon-r {
      bottom: -6vw;
    }

    .bg-heading-el .tech-icon.tech-icon-python {
      bottom: 6vw;
    }

    .bg-heading-el .tech-icon.tech-icon-sql {
      top: 17vw;
    }

    .text-left {
      padding-right: var(--spacing-28);
    }
  }
}

@include bp($bp-mobile) {
  .image-text .text-left {
    width: 100%;
  }
}
.image-text .text-left-m {
  p:last-of-type {
    margin-top: var(--spacing-16);
  }
}
@include bp($bp-mobile) {
  .image-text .text-left-m {
    margin-top: -15px;
    margin-left: 20px;
    margin-right: 20px;
  }
}
.image-text h2 {
  font-size: 40px;
  font-weight: 500;
  margin-bottom: var(--spacing-30);
}

@include bp($bp-laptop) {
  .image-text h2 {
    font-size: 32px;
  }
}

@include bp($bp-mobile) {
  .image-text h2 {
    font-size: 32px;
  }
}
.image-text h2 .blue {
  color: #55bfc7;
  font-weight: 800;
}

.image-text .text-left-par {
  margin: 0;
  line-height: 150%;
}
@include bp($bp-phone) {
  .image-text .text-left-par {
    font-size: 16px;
  }
}

.image-text .image-right {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 965px;
  margin: 0 50px;
  overflow: hidden;
  position: relative;

  .nested-image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    @include bp($bp-mobile) {
      opacity: 1;
    }

    &.first {
      opacity: 1;
    }

    .hide {
      opacity: 0;
    }
  }
}
.image-text .image-right {
  width: 70%;
}

@include bp($bp-laptop) {
  .image-text .image-right {
    max-width: 817px;
    margin: 0;
  }
}
@include bp($bp-mobile) {
  .image-text .image-right {
    width: 100%;
    opacity: 1;
    padding-bottom: 0;
    margin-left: 0;
  }
}
@include bp($bp-phone) {
  .image-text .image-right {
    width: 100%;
    margin: 0 !important;
    margin-left: 40px !important;
    overflow: unset !important;
  }
}
.image-text .image-right img {
  max-width: 100%;
  transition: opacity 0.8s ease-in-out;
}
@include bp($bp-laptop) {
  .image-text .image-right img {
  }
}

.pin-section .accordion {
  margin-top: var(--spacing-30);

  .accordion-item {
    margin-bottom: var(--spacing-16);
    padding-bottom: var(--spacing-16);

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .accordion-header {
      font-size: 21px;
    }

    .accordion-content p {
      color: var(--main-dark-light-2);
    }
  }
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 1s ease-out;
}
.accordion-content p {
  font-size: 16px;
  color: var(--main-dark-shade-3);
  margin-bottom: 0;
  line-height: 150%;
}
@include bp($bp-phone) {
  .accordion-content p {
    font-size: 16px;
  }
}

.accordion-item {
  margin-bottom: var(--spacing-24);
  padding-bottom: var(--spacing-24);
  border-bottom: 1px solid #e0e2e4;
}
.accordion-item svg {
  transition: transform 0.3s ease-in-out;
}
.accordion-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border: 0;
}

.accordion-item.active .accordion-content {
  transition: max-height 1s ease-out;
  max-height: 1000px;
}

.accordion-item.active svg {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.bg-heading-el {
  position: relative;

  .relative {
    position: relative;

  }

  .tech-icon {
    position: absolute;
    z-index: -1;

    @include bp($bp-mobile) {
      transform: translate3d(0px, -67px, 0px) !important
    }

    &.tech-icon-python {
      bottom: 100%;
      right: 0;

      @include bp($bp-mobile) {
        width: 60px;
        bottom: auto;
        top: -70vw;
      }
    }

    &.tech-icon-sql {
      left: 100%;
      top: 100%;

      @include bp($bp-mobile) {
        top: auto;
        bottom: calc(100% + 140px);
        left: -30px;
      }
    }

    &.tech-icon-r {
      bottom: 0;
      left: 30px;

      @include bp($bp-mobile) {
        width: 60px;
        bottom: auto;
        top: calc(100% + 60px);
        left: auto;
        right: 10px;
      }
    }
  }
}
.bg-heading-el h2 {
  margin-bottom: 0;
}
.bg-heading-el .sub-heading {
  color: #748190;
  font-size: 21px;
  font-weight: 500;
  text-align: right;
  padding-right: 30px;
  margin-top: 10px;
}
@include bp($bp-mobile) {
  .bg-heading-el .sub-heading {
    text-align: left;
  }
}
.bg-heading-el .text-left-par {
  margin-top: 20px;
}

.how-it-work {
  padding: var(--spacing-120) 0;
  background: #000c1f;
  position: relative;
}
@include bp($bp-mobile) {
  .how-it-work {
    padding: 0;
  }
}
.how-it-work h2 {
  font-size: 40px;
  color: var(--main-light);
  font-weight: 500;
  text-align: center;
  margin-bottom: 30px;
}

@include bp($bp-laptop) {
  .how-it-work h2 {
    font-size: 32px;
  }
}

@include bp($bp-mobile) {
  .how-it-work h2 {
    font-size: 32px;
    padding-top: 80px;
  }
}

@include bp($bp-phone) {
  .how-it-work h2 {
    padding-right: var(--spacing-24);
    padding-left: var(--spacing-24);
  }
}

.how-it-work .how-it-work-btn {
  text-align: center;

  .btn-primary {
    padding: var(--spacing-24) 0 var(--spacing-20);
    margin-top: 0;

    &:not(.filled) {
      color: var(--main-dark);
      background: var(--main-dark-light-2);
      border-color: var(--main-dark-light-2);
    }
  }
}
@include bp($bp-phone) {
  .how-it-work .how-it-work-btn {
    padding-right: var(--spacing-24);
    padding-left: var(--spacing-24);
  }
}

.work-steps {
  position: relative;
}
@include bp($bp-mobile) {
  .work-steps {
    padding: 0 20px 0 70px;
  }
}
.work-steps .progress {
  position: absolute;
  top: 94px;
  left: 49%;
}
@include bp($bp-phone) {
  .work-steps .progress {
    left: 10px;
    top: 30px;
  }
}

.tracker {
  > div {
    display: block;
    overflow: hidden;
    padding-top: 7.5px;
    position: relative;

    .track-dot {
      display: block;
      width: 34px;
      height: 34px;
      top: -7px;
      border-radius: 50%;
      content: '';
      position: absolute;
      transition: all var(--duration) ease-in;
      background-color: var(--main-dark-shade-2);

      &.filled {
        background-color: var(--accent);
      }
    }

    > div {
      position: relative;
      padding: 0 0 71px;
    }

    &:nth-child(even) {
      > div {
        float: right;

        .track-dot {
          left: -17px;
        }
      }
    }

    &:nth-child(odd) {
      > div {
        float: left;

        .track-dot {
          right: -17px;
        }
      }
    }

    .track {
      .h3 {
        font-size: 40px;
        font-weight: 700;
        margin: 0 0 var(--spacing-8);
        color: var(--accent);
      }

      span {
        &.h5 {
          display: inline-block;
          font-size: 28px;
          font-weight: 500;
          margin-bottom: var(--spacing-12);
          color: var(--main-light);
        }

        &.body-1 {
          font-size: 18px;
          line-height: 150%;
          color: var(--main-light-shade-3);
        }
      }
    }
  }

  @include bp($bp-phone) {
    margin-bottom: var(--spacing-30);
    padding-bottom: 0;

    > div {
      margin-top: 0;

      > div {
        padding: 0 0 30px;
      }

      &:last-of-type {
        > div {
          .track {
            padding-bottom: 0;
          }
        }
      }

      &:nth-child(odd),
      &:nth-child(even) {
        > div {
          float: left;

          .track-dot {
            top: 0;
            left: 0;
            right: auto;
            height: 24px;
            width: 24px;
          }
        }
      }
    }

    .track {
      padding: 0 var(--spacing-16) var(--spacing-24) var(--spacing-20);
    }
  }
}

.container:has(.track-line) {
  position: relative;
}

.track-line {
  background: var(--main-dark-shade-2);
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  overflow: hidden;
  z-index: 0;

  .track-line-filler {
    background-color: var(--accent);
    position: absolute;
    top: 2px;
    left: 0;
    width: 100%;
    height: 0;
    max-height: 100%;
  }

  + * {
    z-index: 1;
  }

  @include bp($bp-phone) {
    height: calc(100% - 20px);
    left: 0;
    transform: translate(30px, calc(-50% + 2px));

    .track-line-filler {
      top: -7px;
    }
  }
}

@include bp($bp-phone) {
  .track-line {
    margin-left: 5px;
  }
}

.work-info-box {
  width: 28vw;
  padding: 32px 0;

  &.first {
    padding-top: 0;
  }
}
@include bp($bp-phone) {
  .work-info-box {
    width: 100%;
  }
}
.work-info-box .step-num {
  font-size: 40px;
  color: var(--accent);
  margin-bottom: 10px;
  font-weight: 600;
}
@include bp($bp-phone) {
  .work-info-box .step-num {
    font-size: 32px;
  }
}
.work-info-box h3 {
  font-size: 28px;
  font-weight: 500;
  color: var(--main-light);
  margin: 10px 0;
}
.work-info-box p {
  font-size: 18px;
  color: var(--main-light);
}
.work-info-box.left {
  margin-right: auto;
}
.work-info-box.right {
  margin-left: auto;
}

.what-will-you-get {
  padding-top: 240px;

  h2 {
    margin-bottom: var(--spacing-40);
  }
}

@include bp($bp-laptop) {
  .what-will-you-get {
    padding-top: var(--spacing-120);
  }
}

@include bp($bp-mobile) {
  .what-will-you-get {
    padding: 0 0 var(--spacing-80);
  }
}

.benefit-wrapper {
  .row:first-of-type {
    margin-bottom: 64px;
  }
}

@include bp($bp-mobile) {
  .benefit-wrapper {
    .row {
      gap: var(--spacing-30);

      &:first-of-type {
        margin-bottom: var(--spacing-30);
      }
    }
  }
}

.benefit-box {
  display: flex;
  gap: var(--spacing-12);

  .right-side {
    flex: 1;

    p {
      margin: 0;
    }
  }
}
@include bp($bp-mobile) {
  .benefit-box {
  }
}
@include bp($bp-phone) {
  .benefit-box {

  }
}
.benefit-box h3 {
  display: flex;
  align-items: center;
  color: var(--main-light);
  font-size: 24px;
  font-weight: 500;
}
.benefit-box h3.yellow {
  color: #edc843;
}
.benefit-box h3.blue {
  color: var(--accent);
}
.benefit-box h3 svg {
  margin-right: 10px;
}
.benefit-box p {
  color: #abafb5;
  font-size: 18px;
}

.hero-skills-wrapper {
  position: absolute;
  bottom: 10vw;
  background: var(--main-light);
  width: 240px;
  overflow: hidden;
  border-radius: 10px;
  animation: scaleAnimation 0.5s forwards;
  padding: var(--spacing-16) var(--spacing-22);
  box-shadow: 0px 4.085px 15.32px 0px rgba(0, 12, 31, 0.25);
}

@include bp($bp-laptop) {
  .hero-skills-wrapper {
    width: 200px;
    padding: 13px var(--spacing-18);
    bottom: 3vw;
  }
}

@include bp($bp-phone) {
  .hero-skills-wrapper {
    width: 166px;
    bottom: -2vw;
    padding: var(--spacing-8) 11px;

    .skill-level {
      margin-top: var(--spacing-4);
    }

    .skill-name {
      font-size: 12px;
    }

    .skill-labels {
      margin: 3px 0 var(--spacing-4);

      .skill-bar {
        font-size: 7px;
        height: 7px;
      }
    }
  }
}

.hero-skills-wrapper .swiper-slide {
  margin-bottom: 15px;
}
.hero-skills-wrapper .skill-name {
  color: #000;
}
.hero-skills-wrapper .skill-bars {
  justify-content: space-between;
}
.hero-skills-wrapper .skill-bars .skill-bar {
  background: #efeff1;
  border: 2px solid #bbbec2;
  position: relative;
  border-radius: 7px;
}
.hero-skills-wrapper .skill-bars .skill-bar.filled:before {
  content: "";
  position: absolute;
  background: var(--main-red);
  width: 0%;
  height: 100%;
  border-radius: 7px;
  animation: fillWidth 1s forwards 0.5s;
}
.hero-skills-wrapper .skill-bars .skill-bar.filled-blue:before {
  content: "";
  position: absolute;
  background: var(--accent);
  width: 100%;
  height: 100%;
  border-radius: 7px;
}
.hero-skills-wrapper .skill-bars .skill-bar.filled-yellow:before {
  content: "";
  position: absolute;
  background: #edc843;
  width: 100%;
  height: 100%;
  border-radius: 7px;
}

.swiper-pagination {
  position: absolute;
  bottom: 16px !important;
  left: 50%;
  transform: translateX(-50%);
}

@include bp($bp-laptop) {
  .swiper-pagination {
    bottom: 13px !important;
  }
}

@include bp($bp-phone) {
  .swiper-pagination {
    bottom: 8px !important;
  }
}

.swiper-pagination :deep(.swiper-pagination-bullet) {
  width: 6px;
  height: 6px;
  background-color: #abafb5;
  opacity: 1;
  margin: 0 2.5px;
}

@include bp($bp-laptop) {
  .swiper-pagination :deep(.swiper-pagination-bullet) {
    width: 5px;
    height: 5px;
    margin: 0 2px;
  }
}

@include bp($bp-phone) {
  .swiper-pagination :deep(.swiper-pagination-bullet) {
    width: 3px;
    height: 3px;
    margin: 0 1.3px;
  }
}

.swiper-pagination :deep(.swiper-pagination-bullet-active) {
  background: var(--accent);
}

.swiper-slide {
  opacity: 0 !important;
}

.swiper-slide-active {
  opacity: 1 !important;
}

@keyframes scaleAnimation {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes fillWidth {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@include bp($bp-mobile) {
  .image-text {
    display: flex !important;
    flex-direction: column-reverse;
    overflow: hidden;
  }
}

.anim-elem {
  opacity: 0;
}

#myNavbar {
  display: none;
}

@include bp($bp-mobile) {
  #myNavbar {
    display: block;
  }
  .navbar {
    overflow: hidden;
  }
  .navbar a {
    float: left;
    display: block;
    color: var(--main-light);
    text-align: center;
    padding: 14px 20px;
    text-decoration: none;
  }
  .navbar .icon {
    display: none;
  }
  .navbar .mobile-nav:not(:first-child) {
    display: none;
  }
  .navbar a.icon {
    float: right;
    display: block;
  }
  .navbar.responsive {
    position: relative;
  }
  .navbar.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .navbar.responsive .mobile-nav {
    float: none;
    display: block;
    text-align: left;
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    padding-left: 0;
  }
}

.swiper-container-slide-mobile {
  overflow: hidden;
  display: none;
}
@include bp($bp-mobile) {
  .swiper-container-slide-mobile {
    display: block;
  }
}

@include bp($bp-mobile) {
  .techs-img {
    display: none;
  }
}

.faq-section {
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-100);
}

@include bp($bp-laptop) {
  .faq-section {
    .row {
      .empty-column {
        display: none;
      }
    }
  }
}

@include bp($bp-phone) {
  .faq-section {
    padding-top: var(--spacing-60);
    padding-bottom: var(--spacing-60);
  }
}
.faq-section .accordion-item svg {
  transform: rotate(90deg);
}
@include bp($bp-mobile) {
  .faq-section .accordion-item svg {
    width: 30px;
  }
}
.faq-section .accordion-item.active svg {
  transform: rotate(0);
}

.faq-text {
  width: 24%;
}
@include bp($bp-mobile) {
  .faq-text {
    width: 100%;
  }
}
.faq-text h2 {
  font-size: 32px;
}

.faq-text p {
  line-height: 150%;
  margin: 0;
}

@include bp($bp-mobile) {
  .faq-text p {
    margin-bottom: var(--spacing-30);
  }
}

@include bp($bp-mobile) {
  .faq-text h2 {
    font-size: 32px;
  }
}

.faq {
  width: 70%;
}
@include bp($bp-mobile) {
  .faq {
    width: 100%;
  }
}

.cta-section {
  padding: var(--spacing-100) 185px var(--spacing-120) 185px;
}
@include bp($bp-mobile) {
  .cta-section {
    padding: 0 20px 120px 20px;
  }
}

@include bp($bp-phone) {
  .cta-section {
    padding: var(--spacing-60) var(--spacing-24) var(--spacing-80);
  }
}

.cta-section h2 {
  font-size: 40px;
  text-align: center;

  margin-bottom: var(--spacing-20);
}

@include bp($bp-laptop) {
  .cta-section h2 {
    font-size: 32px;
    margin-bottom: var(--spacing-30);
  }
}

@include bp($bp-mobile) {
  .cta-section h2 {
    font-size: 32px;
  }
}
.cta-section .cta-btn {
  text-align: center;
}

#permas {
  height: 150px;
  bottom: 0;
  background: blue;
  position: absolute;
  overflow: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  /* added */
  left: 0;
  animation-name: scroll;
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

#permas img {
  height: 100%;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.slider-gallery {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-bottom: 20px;
}
.slider-gallery:nth-child(2) {
  padding-left: 80px;
}

.slides {
  display: flex;
  animation: slide-animation 30s linear infinite;
}

.slides img {
  margin: 0 10px;
}
@include bp($bp-mobile) {
  .slides img {
    width: 150px;
  }
}

.circular-progress {
  --size: 250px;
  --half-size: 125px;
  --stroke-width: 30px;
  --radius: 110px;
  --circumference: 691.15038px;
  --dash: calc((var(--progress) * var(--circumference)) / 100);
  animation: progress-animation 1s linear 0s 1 forwards;
}

.circular-progress circle {
  cx: var(--half-size);
  cy: var(--half-size);
  r: var(--radius);
  stroke-width: var(--stroke-width);
  fill: none;
  stroke-linecap: round;
}

.circular-progress circle.bg {
  stroke: #062644;
}

.circular-progress circle.fg {
  transform: rotate(-90deg);
  transform-origin: var(--half-size) var(--half-size);
  stroke-dasharray: var(--dash) calc(var(--circumference) - var(--dash));
  transition: stroke-dasharray 0.3s linear 0s;
  stroke: #edc843;
}

:root {
  --progress: 0;
}

@keyframes progress-animation {
  from {
    --progress: 0;
  }
  to {
    --progress: 30;
  }
}

.candidate-score {
  color: var(--main-light);
  text-align: center;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.candidate-score .score {
  font-size: 30px;
  margin: 0;
}
.candidate-score .overall {
  .desktop {
    display: inline;
  }

  .phone {
    display: none;
  }

  margin-top: 10px;
  margin-bottom: 0;
  font-size: 14px;
  color: #abafb5;
}

.skill-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--Lights-and-Shades-Main-Light, var(--main-light));
  text-transform: capitalize;
  font-size: 12px;
  line-height: 140%;
  font-weight: 500;
}

@include bp($bp-laptop) {
  .skill-name {
    font-size: 10px;
  }
}

@include bp($bp-mobile) {
  .skill-name {
    font-size: 14px;
  }
}

.skill-level {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: var(--spacing-8);
}

@include bp($bp-laptop) {
  .skill-level {
    margin-top: var(--spacing-6);
  }
}

.skill-bars {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.skill-bar {
  width: 110px;
  height: 9px;
  border-radius: 6px;
}

@include bp($bp-laptop) {
  .skill-bars {
    gap: 6px;

    .skill-bar {
      height: 7.5px;
    }
  }
}

@include bp($bp-phone) {
  .skill-bar {
    height: 7px;
  }
}

.filled {
  background-color: var(--accent);
}

.empty {
  background-color: rgba(240, 240, 242, 0.18);
  border: 1px solid #545c69;
}

.skill-labels {
  display: flex;
  justify-content: space-between;
  margin: var(--spacing-6) 0 var(--spacing-8);
  gap: 8px;
  color: var(--Neutral-Main-Dark-Light-4, #748190);
  line-height: 143%;

  .skill-bar {
    height: 14px;
    font-size: 10px;
    text-align: center;
  }
}

@include bp($bp-laptop) {
  .skill-labels {
    gap: 6px;
    margin: 5px 0 var(--spacing-6);

    .skill-bar {
      height: 11px;
      font-size: 8px;
    }
  }
}

@include bp($bp-mobile) {
  .skill-labels {
    font-size: 12px;
  }
}

.skill-label-center {
  text-align: center;
}

.skill-label-right {
  text-align: right;
  color: var(--Neutral-Main-Light-Shade-4, #abafb5);
  font-weight: 600;
}

@keyframes slide-animation {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

</style>
